"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChannelSearch = exports.CHAT_SEARCH_RESULTS_PAGE_SIZE = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _streamChatReact = require("stream-chat-react");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CHAT_SEARCH_RESULTS_PAGE_SIZE = 10;
exports.CHAT_SEARCH_RESULTS_PAGE_SIZE = CHAT_SEARCH_RESULTS_PAGE_SIZE;
var useChannelSearch = function useChannelSearch(channel, searchText, setSearchText, filters) {
  var initialPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    searchResults = _useState2[0],
    setSearchResults = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingResults = _useState4[0],
    setLoadingResults = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    hasMore = _useState6[0],
    setHasMore = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var _useState9 = (0, _react.useState)(initialPage),
    _useState10 = _slicedToArray(_useState9, 2),
    page = _useState10[0],
    setPage = _useState10[1];
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    client = _useChatContext.client;
  (0, _react.useEffect)(function () {
    var filtersEmpty = (0, _lodash.every)((0, _lodash.values)(filters), _lodash.isEmpty);
    if (!searchText && filtersEmpty) {
      return;
    }
    // We only set search text empty again if the filter is set
    if (!filtersEmpty) {
      setSearchText(null);
    }
    onSearch();
  }, [searchText, filters]);
  var onSearch = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var page,
        messageFilters,
        channelFilters,
        paginationFilters,
        res,
        searchResultsSize,
        hasMoreResults,
        results,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
              setLoadingResults(true);
              messageFilters = [];
              channelFilters = [];
              paginationFilters = {
                limit: CHAT_SEARCH_RESULTS_PAGE_SIZE + 1,
                offset: page * CHAT_SEARCH_RESULTS_PAGE_SIZE
              };
              if (!(0, _lodash.isEmpty)(filters.has)) {
                messageFilters.push({
                  'attachments.type': {
                    $in: filters.has
                  }
                });
              }
              if (!(0, _lodash.isEmpty)(filters.mentions)) {
                // only `$contains` operator is supported for `mentioned_users`
                messageFilters.push({
                  'mentioned_users.id': {
                    $contains: filters.mentions[0]
                  }
                });
              }
              if (!(0, _lodash.isEmpty)(filters.from)) {
                // the query for this type of request is different, uses both kinds of filters
                messageFilters.push({
                  'user.id': {
                    $in: [filters.from[0]]
                  }
                });
                channelFilters.push({
                  cid: channel === null || channel === void 0 ? void 0 : channel.cid
                });
              }

              // We never actually search by combination of searchText and searchContext,
              // so we only need to search by text when the context is empty
              if (searchText && (0, _lodash.isEmpty)(messageFilters)) {
                messageFilters.push({
                  text: {
                    $autocomplete: searchText
                  }
                });
              }
              _context.prev = 9;
              if (!(0, _lodash.isEmpty)(filters.from)) {
                _context.next = 16;
                break;
              }
              _context.next = 13;
              return channel.search({
                $and: messageFilters
              }, paginationFilters);
            case 13:
              _context.t0 = _context.sent;
              _context.next = 19;
              break;
            case 16:
              _context.next = 18;
              return client.search(channelFilters[0], messageFilters[0], paginationFilters);
            case 18:
              _context.t0 = _context.sent;
            case 19:
              res = _context.t0;
              searchResultsSize = (0, _lodash.size)(res.results);
              hasMoreResults = searchResultsSize > CHAT_SEARCH_RESULTS_PAGE_SIZE;
              setHasMore(hasMoreResults);
              results = hasMoreResults ? res.results.slice(0, CHAT_SEARCH_RESULTS_PAGE_SIZE) : res.results;
              setSearchResults(results);
              _context.next = 30;
              break;
            case 27:
              _context.prev = 27;
              _context.t1 = _context["catch"](9);
              setError('Something went wrong');
            case 30:
              _context.prev = 30;
              setLoadingResults(false);
              return _context.finish(30);
            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 27, 30, 33]]);
    }));
    return function onSearch() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    loading: loadingResults,
    results: searchResults,
    error: error,
    hasMore: hasMore,
    prev: function prev() {
      if (page === 0) {
        return;
      }
      setPage(function (p) {
        return p - 1;
      });
      onSearch(page - 1);
    },
    next: function next() {
      if (!hasMore) {
        return;
      }
      setPage(function (p) {
        return p + 1;
      });
      onSearch(page + 1);
    },
    page: page,
    sizeLabel: "".concat(page * CHAT_SEARCH_RESULTS_PAGE_SIZE + (0, _lodash.size)(searchResults)).concat(hasMore ? '+' : ''),
    clearSearchResults: function clearSearchResults() {
      setSearchResults(null);
      setSearchText(null);
      setHasMore(null);
      setError(null);
      setPage(0);
    }
  };
};
exports.useChannelSearch = useChannelSearch;